"use strict";

angular.module("customer")
.service("NoOrderNotificationService", function(
    $resource, FlashBag, appConfig, ReadOnlyPermissionService
) {
    this.submitEmptyOrder = function(vendorId, deliveryDate) {
        var service = $resource(appConfig.API_SERVER + "/catalog/customer/orders/no-order-notification/", {}, {
            save: {method: "POST", interceptor: {responseError: ReadOnlyPermissionService.responseErrorInterceptor}}
        });
        return service.save({
            vendor: vendorId,
            delivery_date: deliveryDate
        }).$promise;
    };

    this.submitTokenEmptyOrder = function(token) {
        var service = $resource(appConfig.API_SERVER + "/catalog/customer/orders/no-order-notification/token/", {
            save: {method: "POST", interceptor: {responseError: FlashBag.responseErrorInterceptor}}
        });
        return service.save({token: token}).$promise;
    };

    this.submitSalesRepEmptyOrder = function(partnershipId) {
        var service = $resource(appConfig.API_SERVER + "/catalog/customer/orders/no-order-notification/sales-rep/", {
            save: {method: "POST", interceptor: {responseError: FlashBag.responseErrorInterceptor}}
        });
        return service.save({partnership: partnershipId}).$promise;
    };
});



//////////////////
// WEBPACK FOOTER
// ./customer/sections/order/no-order-notification/no-order-notification.service.js
// module id = 903
// module chunks = 0